define('lib/backbone/Backbone.Mixins.StateMachine',['require','jquery','underscore'],function(require) {

  var $ = require('jquery');
  var _ = require('underscore');

  return {
    currentState: 'start',
    currentStateIndex: 0,

    initStateMachine: function() {
      this.leaveState = this.leaveState || {};
      this.states = this.states || [];
    },

    toState: function(stateName, stateIndex, stateParams) {
      // validate if transition is possible
      this.validateConditions(this.currentState, stateName, stateParams).done(_.bind(this.transition, this, stateName, stateIndex, stateParams));
    },

    transition: function(stateName, stateIndex, stateParams) {
      var enter;
      var self = this;
      var oldState = this.currentState;
      var leave = this.leaveState[this.currentState];
      var leaveDfd;

      if (_.isFunction(this[leave])) {
        leaveDfd = this[leave](stateName, stateParams);
      }

      this.currentState = stateName;
      if (stateIndex) {
        this.currentStateIndex = stateIndex;
      } else {
        this.currentStateIndex = _.indexOf(this.states, stateName);
        if (this.currentStateIndex === -1) {
          this.currentStateIndex++;
        }
      }

      enter = this.enterState[stateName];

      if (_.isFunction(this['beforeStateEnter'])) {
        this['beforeStateEnter'](stateName);
      }

      if (_.isFunction(this[enter])) {
        if (leaveDfd) {
          leaveDfd.done(function() {
            self[enter](oldState, stateParams);
          });
        } else {
          this[enter](oldState, stateParams);
        }
      }
    },

    bindCondition: function(fromState, toState, func) {
      var fromHash;

      if (_.isUndefined(this.transitionConditions)) {
        this.transitionConditions = {};
      }

      if (_.isUndefined(this.transitionConditions[fromState])) {
        this.transitionConditions[fromState] = {};
      }

      fromHash = this.transitionConditions[fromState];

      if (_.isUndefined(fromHash[toState])) {
        fromHash[toState] = [];
      }

      fromHash[toState].push(func);
    },

    // will unbind all condition functions for a certain state transition
    unbindCondition: function(fromState, toState) {
      if (_.isObject(this.transitionConditions[fromState])) {
        delete this.transitionConditions[fromState][toState];
      }
    },

    unbindAllConditions: function() {
      this.transitionConditions = {};
    },

    validateConditions: function(fromState, toState, stateParams) {
      var asyncs = [];
      var dfd = new $.Deferred();
      var passed = true;

      if (!_.isObject(this.transitionConditions) || !_.isObject(this.transitionConditions[fromState]) || !_.isArray(this.transitionConditions[fromState][toState])) {
        dfd.resolve();
        return dfd;
      }

      _.each(this.transitionConditions[fromState][toState], function(func) {
        var result = func(fromState, toState, stateParams);

        if (_.isPromise(result)) {
          asyncs.push(result);
        } else if (_.isBoolean(result)) {
          passed = passed && result;
        } else {
          throw new Error('One of the conditions does not return a boolean or a deferred');
        }
      });

      if (passed && _.isEmpty(asyncs)) {
        dfd.resolve();
      } else if (!passed) {
        dfd.reject();
      } else {
        return $.when.apply(this, asyncs);
      }

      return dfd;
    },

    refreshState: function() {
      this.toState(this.currentState);
    },

    nextState: function() {
      this.toState(this.states[++this.currentStateIndex], this.currentStateIndex);
    },

    prevState: function() {
      this.toState(this.states[--this.currentStateIndex], this.currentStateIndex);
    }
  };

});

